var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlashFilled = function SvgFlashFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.484.125a1 1 0 0 1 .502 1.04L10.181 6H13a1 1 0 0 1 .707 1.708l-8 8a1 1 0 0 1-1.693-.873L4.819 10H1a1 1 0 0 1-.664-1.748l9-8a1 1 0 0 1 1.148-.127Z",
    clipRule: "evenodd"
  })));
};
export default SvgFlashFilled;